module.exports = __webpack_public_path__ + "img/Faixa-continua.849126f7.png";